import { cn } from '@/lib/cn';
import React from 'react';

interface CustomFieldHelperTextProps extends React.ComponentProps<'p'> {
  error?: string;
  description?: string | null;
}

export function CustomFieldHelperText({
  error,
  description,
  className,
  ref,
  ...props
}: CustomFieldHelperTextProps) {
  if (!description && !error) return null;

  return (
    <p
      ref={ref}
      className={cn(
        'mt-2 text-xs',
        error ? 'font-medium text-destructive' : 'text-muted-foreground',
        className
      )}
      role={error ? 'alert' : 'region'}
      aria-live='polite'
      {...props}
    >
      {error || description}
    </p>
  );
}
